import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
  errorOnActivation,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Region
function getLimitedReleaseByPhysical(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createLimitedReleaseByPhysical(requestBody, queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editLimitedReleaseByPhysical(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteLimitedReleaseByPhysical(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function activateLimitedReleaseByPhysical(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/activate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(errorOnActivation)
    .then((data) => {
      return data;
    });
}

function deactivateLimitedReleaseByPhysical(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/deactivate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const limitedReleasesPhysicalService = {
  getLimitedReleaseByPhysical,
  createLimitedReleaseByPhysical,
  editLimitedReleaseByPhysical,
  deleteLimitedReleaseByPhysical,
  activateLimitedReleaseByPhysical,
  deactivateLimitedReleaseByPhysical,
};
